import "@aws-amplify/ui-react/styles.css";
import { withAuthenticator } from "@aws-amplify/ui-react";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import { LabpadreNavbar } from "./app/navbar";
import { PendingMessagesList } from "./features/pendingMessages/pendingMessagesList";
import { CommentatorsView } from "./features/commentators/commentators";
import { StreamLayout } from "./features/streamLayout/streamLayout";

// https://github.com/aws-amplify/amplify-ui/pull/1724 introduced this nonsense
type LoggedInProps = {
  appRoute: string;
  cookies: any;
  user: any;
  signOut: any;
};

function App(props: any) {
  const { user, signOut }: LoggedInProps = props;
  return (
    <BrowserRouter>
      <LabpadreNavbar user={user} signOut={signOut} />
      <div className="App">
        <Routes>
          <Route path="/" element={<PendingMessagesList />} />
          <Route path="/commentators" element={<CommentatorsView />} />
          <Route path="/stream-layout" element={<StreamLayout />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default withAuthenticator(App, { hideSignUp: true });
